<template>
  <van-popup
    v-model="show"
    class="popup"
    :class="position"
    :style="customStyle"
    :close-on-click-overlay="canOverlay"
    :position="position"
    :round="round"
    @closed="$emit('closed')"
  >
    <div class="white title font-w-b" v-if="title">{{ title }}</div>
    <slot></slot>
  </van-popup>
</template>

<script>
export default {
  naem: "",
  data() {
    return {
      show: this.value,
    };
  },
  watch: {
    value(val) {
      this.show = val;
    },
    show(val) {
      this.$emit("input", val);
    },
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    title: {
      type: String,
      default: "",
    },
    canOverlay: {
      type: Boolean,
      default: true,
    },
    position: {
      type: String,
      default: "center",
    },
    round: {
      type: Boolean,
      default: false,
    },
    customStyle: {
      type: Object,
    },
  },
};
</script>

<style lang="less" scoped>
.center {
  padding: 1.5rem;
  border-radius: 1rem;
  background: #002748;
  min-width: 17.5rem;
  display: flex;
  flex-direction: column;
  align-items: center;
}

.title {
  font-size: 1.125rem;
  height: 3.5625rem;
  display: flex;
  align-items: center;
  justify-content: center;
}

.bottom {
  width: 768px;
  left: calc(50% - 384px);
  background: #002748;

  ::-webkit-scrollbar-track {
    background: #002748;
  }
  ::-webkit-scrollbar-thumb {
    border-radius: 5px;
    background: #001235;
  }

  @media screen and (max-width: 768px) {
    width: 100%;
    left: 0;
  }
}
</style>


// WEBPACK FOOTER //
// src/components/Popup.vue